enum TwitterSearchType {
  USER = 1,
}

export default TwitterSearchType;
